// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"9d5d597b","515":"4ca06948","539":"718686f8","734":"3296fadb"}[chunkId] + ".chunk.css";
};